"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryCardSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Delivery card skeleton to be displayed when DeliveryCard data is being loaded.
 * The skeleton is a separate component to be replaced by the final DeliveryCard when
 * the data loading is complete.
 * @param className className of the whole DeliveryCardSkeleton
 * @param props testId of the whole DeliveryCardSkeleton
 * @returns JSX.Element
 */
const DeliveryCardSkeleton = ({
  className,
  testId
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
  className: className,
  "data-testid": testId,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    height: 31,
    variant: "rounded",
    width: 100,
    sx: {
      marginBottom: 4
    }
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    height: 26,
    variant: "rounded",
    width: 60,
    sx: {
      marginBottom: 1
    }
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    height: 22,
    variant: "rounded",
    width: 206,
    sx: {
      marginBottom: 1
    }
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    height: 22,
    variant: "rounded",
    width: 206
  })]
});
exports.DeliveryCardSkeleton = DeliveryCardSkeleton;
var _default = exports.default = DeliveryCardSkeleton;
//# sourceMappingURL=DeliveryCardSkeleton.js.map